import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'availableProviders',
  getURL: 'mainHubs/mainHubId/thirdPartyProviders',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  sessionParams: ['mainHubId'],
  fields: [
    {
      attributeName: 'id',
      label: 'Id',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canFilter: true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the Provider.',
      exactWidth: '10px',
      hidden: true
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canFilter: true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the Provider.',
      exactWidth:'10px'
    },
    {
      attributeName: 'thirdPartyType',
      label: 'Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canFilter: true,
      canEdit: false,
      canCreate: false,
      helpText: 'Type of the Provider.',
      exactWidth:'10px'
    },
  ],
};
